import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';

import SingleLeyendLabel from '../../../../support/SingleLeyendLabel';

const GenericCardRenderItems = ({ data = {}, subtitle = '', labels = [], children }, width = 200) => {
  const renderLeyends = (item) => {
    return (
      <SingleLeyendLabel
        key={item.index}
        label={item.label}
        index={item.index}
        data={data}
        width={width}
        render={item.render}
      />
    );
  };

  return (
    <Card className="mb-2">
      <Card.Body>
        <Card.Subtitle className="text-left">
          <div className="d-block mt-3 mb-2">{subtitle || ''}</div>
        </Card.Subtitle>
        <Row className="d-block mt-2 mb-2">
          <Col>
            {labels.map(renderLeyends)}
            {children}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default GenericCardRenderItems;
